import { ComponentType } from 'react';
import { reloadPage } from 'lib/browserNavigation';

// This solution was based on https://www.codemzy.com/blog/fix-chunkloaderror-react

// This function triggers a page refresh when an import fails
// This is a way to handle "ChunkLoadError" right after a deploy
export const lazyRetry = (componentImport, name): Promise<{ default: ComponentType<any> }> => {
  const storageKey = `retry-${name}-refreshed`;
  const hasRefreshed = JSON.parse(
    window.sessionStorage.getItem(storageKey) || 'false',
  );

  return componentImport()
    .then((component) => {
      window.sessionStorage.setItem(storageKey, 'false');

      // Handle double-wrapping from --experimental-vm-modules
      // When using --experimental-vm-modules, dynamic imports may return
      // { default: { default: Component } } instead of { default: Component }
      if (component.default && typeof component.default === 'object' && 'default' in component.default) {
        return component.default;
      }

      return component;
    })
    .catch((error) => {
      // When an error happens, if the import for this component didn't trigger a refresh
      // Then it triggers a refresh
      if (!hasRefreshed && error.message === 'ChunkLoadError') {
        window.sessionStorage.setItem(storageKey, 'true');
        reloadPage();

        return new Promise(() => { }); // Never resolves (page is reloading)
      }

      // If this is the second refresh we throw the error so it can be handled
      throw error;
    });
};

export default lazyRetry;
